"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToStringKey = void 0;
function dateToStringKey(date) {
    return date.getFullYear() + "-" + (date.getMonth() + 1)
        .toString()
        .padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0");
}
exports.dateToStringKey = dateToStringKey;
